import { render } from "./AnnotateLabelPlacement.vue?vue&type=template&id=7718073f&scoped=true"
import script from "./AnnotateLabelPlacement.vue?vue&type=script&lang=js"
export * from "./AnnotateLabelPlacement.vue?vue&type=script&lang=js"

import "./AnnotateLabelPlacement.vue?vue&type=style&index=0&id=7718073f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7718073f"]])

export default __exports__